import api from "./api";

export function getFaq(page = 1, limit = 10, search = "") {
  return api.get(`/faqs?page=${page}&limit=${limit}&search=${search}`);
}

export function getFaqById(id) {
  return api.get(`/faqs/${id}`);
}

export function createFaq(data) {
  return api.post("/faqs", data);
}

export function updateFaq(faq_id, data) {
  return api.put(`/faqs/${faq_id}`, data);
}

export function deleteFaq(id) {
  return api.delete(`/faqs/${id}`);
}
